import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { logoutUser } from "../redux/slices/authSlice";
import { logoutprofile } from "../redux/slices/profileSlice";
import { logoutcertificate } from "../redux/slices/certificateStatusSlice";
import { ATP_LOGIN, USERS_TYPE } from "../data/Constants";
import { handleLogoutAtp } from "../redux/slices/atpSlice";
import { handleTSTCBack } from "../utils/helperFunctions";
import { handleCurrentStep } from "../redux/slices/userInfoStepperSlice";

const useLogout = (userType) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const handleLogOut = () => {
    dispatch(logoutUser());
    dispatch(() => handleTSTCBack({ dispatch, step: 1 }));
    dispatch(handleCurrentStep(1))
    if (user.user_type === USERS_TYPE.USER) {
      dispatch(logoutprofile());
      dispatch(logoutcertificate());
    } else {
      dispatch(handleLogoutAtp());
    }
    localStorage.removeItem("token");
    toast.success("You have successfully logged out");
    navigate(userType && userType === USERS_TYPE.ATP_USER ? ATP_LOGIN : "/");
  };

  return {
    handleLogOut,
  };
};

export default useLogout;
